import React, { useEffect, useState } from 'react';
import ProposalList from '../../../components/proposal';
const Application = (props) => {
    let proposalData = props.proposalData;
        const seedData = [
        {
            name: "Proposal No.",
            value: '',
            key: 'proposalNumber',
            show: true
        },
        {
            name: "Policy No.",
            value: '',
            key: 'policyNumber',
            show: true
        },
        {
            name: "Current stage in mCustomer",
            value: '',
            key: 'proposalStatus',
            show: true
        },
        {
            name: "Auto UW decision",
            value: '',
            key: 'overallUWDecisionCd',
            show: true
        },
        {
            name: "Logged In Agent Code & Designation",
            value: '',
            key: 'designation',
            show: true
        },
        {
            name: "Assigned Agent Code",
            value: '',
            key: 'assignedAgentCode',
            show: true
        }, {
            name: "Channel",
            value: '',
            key: 'channelName',
            show: true
        },
        {
            name: "Sub-Channel",
            value: '',
            key: 'subChannelName',
            show: true
        }

    ]
    const [initialdata, setData] = useState(seedData);
    useEffect(() => {
        // console.log("==============>", props.proposalData)
        const { agentDetails, channelInfo } = props.proposalData;
        let data;
        data = seedData.map((item) => {
            if (agentDetails && agentDetails.otherAgentDetails[item.key]) {
                item.value = item.key === "designation" ? agentDetails.otherAgentDetails['agentCode'] +' '+ agentDetails.otherAgentDetails[item.key] : agentDetails.otherAgentDetails[item.key];
            } else if (channelInfo && channelInfo[item.key]){
                item.value = channelInfo[item.key]
            } else if (props.proposalData[item.key]) {
                item.value = props.proposalData[item.key]
            }
            return item;
        })
        setData(data)
    }, [props.proposalData])
    return (
        <div className="main_container">
            <ProposalList initialdata={initialdata} proposalData={proposalData} />
        </div>
    )
}

export default Application;